import _ from 'lodash';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
const $ = require('jquery');
import 'jquery-ui';
import Flickity from 'flickity';
import IMask from 'imask';

import "./styles.scss";

import "./js/shared/pageComponents";
import "./js/shared/loadAssets";
import "./js/shared/formHandling";
import "./js/shared/gfRequiredFields"
import "./js/shared/gfAccordionSections";
import "./js/shared/gfPayrollModal";
import "./js/shared/cookies";
import "./js/shared/EmblaCarousel";
import "./js/pages/header";
import "./js/pages/home";
import "./js/pages/contact-us";
import "./js/pages/testimonials";
import "./js/pages/posts";
import "./js/landing-pages/innerPageFunctions";
import "./js/landing-pages/landingPageLayout";
import "./js/landing-pages/landingPageForm";
import "./js/jquery/theme";

import initializeChatbot from "./js/chatbot/chatbotLoader";

const chatContainer = document.getElementById("chat-container");
if (chatContainer) {
    initializeChatbot();
}